"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textAndA11yText = exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _airbnbPropTypes = _interopRequireDefault(require("airbnb-prop-types"));
var _props = require("../utils/props");
var _A11yText = _interopRequireDefault(require("../A11yText"));
var _Icon = require("../Icon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const textAndA11yText = exports.textAndA11yText = _airbnbPropTypes.default.childrenOf(_propTypes.default.oneOfType([_airbnbPropTypes.default.elementType(_A11yText.default), _propTypes.default.string]));
const buttonPropTypes = {
  tokens: (0, _props.getTokensPropType)('Button'),
  /**
   * If true, prevents the button from being pressed, changes the cursor (on web) and accessibility
   * attributes to communicate this to the user, and applies `inactive: true` appearances from the theme
   */
  inactive: _propTypes.default.bool,
  /**
   * Alias for `inactive`
   */
  disabled: _propTypes.default.bool,
  /**
   * Button's children must be either:
   *  - One or more text strings and / or A11yText components
   *  - A render function with contents that responds to current button state by being passed an object of:
   * ```
   * { hovered<bool>, focused<bool>, pressed<bool>, inactive<bool>, selected<bool>, textStyles<RNStyle> }
   * ```
   */
  children: _propTypes.default.oneOfType([_propTypes.default.func, textAndA11yText]).isRequired,
  /**
   * Function called when the button is pressed. Required unless the button has a href.
   */
  onPress: _propTypes.default.func,
  /**
   * Optional variant that may be passed down to the link's icon if there is one
   */
  iconProps: _propTypes.default.exact(_Icon.iconComponentPropTypes),
  /**
   * When `icon` is provided, use `iconPosition` to place the Icon to the left or right side of the button.
   */
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  /**
   * A function component for an SVG icon to render inside the link. Inherits size and color from
   * the link and any Typography the link is nested inside.
   */
  icon: _propTypes.default.func,
  variant: _props.variantProp.propType
};
var _default = exports.default = buttonPropTypes;